var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueEditor,{ref:"editorRef",attrs:{"id":_vm.id,"editor-options":_setup.toolbarOptions},on:{"text-change":_setup.updateValue},model:{value:(_setup.content),callback:function ($$v) {_setup.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }